import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  if (typeof window !== 'undefined') {
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    w.fbq('init', '741445578526747');
    w.fbq('track', 'PageView');
  }
})();
document.title = 'Airguard Co2 detector';
render(<App data-id="element-404" />, document.getElementById('root'));